module.exports = __webpack_public_path__ + "static/media/thumbnail.bfa09198.jpg";